import React from 'react';
import type { PropsWithChildren } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { AudienceSegmentationContextProvider } from '@confluence/custom-sites-extensions/entry-points/AudienceSegmentationContext';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
const HubEditorWrapperStyle = styled.div({
	isolation: 'isolate',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& div.fabric-editor-popup-scroll-parent': {
		'--company-hub-editor-gutter-padding-inline': token('space.300'),

		paddingInline: 'var(--company-hub-editor-gutter-padding-inline)',
		paddingBlock: token('space.400'),
		background: token('color.background.accent.gray.subtlest'),

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& div[data-editor-click-wrapper]': {
			width: 'calc(100cqw - var(--company-hub-editor-gutter-padding-inline) * 2 - 8px)',
			maxWidth: `calc(var(--ak-editor--full-width-layout-width) + ${token('space.250')} * 2)`,
			background: token('elevation.surface'),
			alignSelf: 'center',
			height: 'auto',
		},

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& div[data-editor-editable-content]': {
			paddingBlockStart: 0,
		},
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& button[data-editor-block-ctrl-drag-handle]': {
		marginLeft: token('space.050'),
	},
});

export const HubEditorWrapper: React.FC<PropsWithChildren<{}>> = ({ children }) => {
	return (
		<AudienceSegmentationContextProvider isCompanyHub shouldFetchUserGroups>
			<HubEditorWrapperStyle>{children}</HubEditorWrapperStyle>
		</AudienceSegmentationContextProvider>
	);
};
